import React from "react";
import { useNavigate } from "react-router-dom";
import { buildRolePath } from "./roleRoutes";

const COLUMNS = [
  { key: "project_details_name", label: "Project", sortable: true },
  { key: "section_name", label: "Section / workstage", sortable: false },
  { key: "letter_num", label: "Letter no.", sortable: true },
  { key: "date", label: "Date", sortable: true },
  { key: "rev_no", label: "Rev", sortable: false },
  { key: "submitted_to", label: "Submitted to", sortable: false },
  { key: "description", label: "Description", sortable: false },
];

export default function LettersTable({ rows, loading, ordering, onSort }) {
  const navigate = useNavigate();

  const arrowFor = (key) => {
    if (ordering === key) return " ▲";
    if (ordering === `-${key}`) return " ▼";
    return "";
  };

  if (loading) {
    return <div className="letters-table-state">Loading letters…</div>;
  }

  if (!rows.length) {
    return <div className="letters-table-state">No letters match these filters.</div>;
  }

  return (
    <div className="letters-table-card">
      <table>
        <colgroup>
          <col className="col-project" />
          <col className="col-section" />
          <col className="col-letter" />
          <col className="col-date" />
          <col className="col-rev" />
          <col className="col-submitted" />
          <col className="col-desc" />
        </colgroup>
        <thead>
          <tr>
            {COLUMNS.map((col) => (
              <th
                key={col.key}
                onClick={col.sortable ? () => onSort(col.key) : undefined}
                style={{ cursor: col.sortable ? "pointer" : "default" }}
              >
                {col.label}
                {col.sortable ? arrowFor(col.key) : ""}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} onClick={() => navigate(buildRolePath(`letters/${row.id}`))}>
              <td>
                <div className="letters-project-name" title={row.project_details_name}>
                  {row.project_details_name}
                </div>
                {row.project_short_name && (
                  <div style={{ fontSize: 12 }} title={row.project_short_name}>
                    {row.project_short_name}
                  </div>
                )}
              </td>
              <td className="letters-muted">
                <div className="letters-section-name" title={row.section_name}>
                  {row.section_name}
                </div>
                <span style={{ fontSize: 12 }} title={row.workstage_name}>
                  {row.workstage_name}
                </span>
              </td>
              <td title={row.letter_num}>
                {row.letter_num}
                {row.thread_count > 0 && (
                  <span className="letters-thread-flag">
                    {row.thread_count} comment{row.thread_count === 1 ? "" : "s"}
                  </span>
                )}
              </td>
              <td className="letters-muted">{row.date}</td>
              <td className="letters-muted">{row.rev_no}</td>
              <td className="letters-muted" title={row.submitted_to}>
                {row.submitted_to}
              </td>
              <td className="letters-desc-cell" title={row.description}>
                {row.description}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
} 